import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import classNames from 'classnames';
import Loader from '@adsk/bim360-matrix-react-loader';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';

import './_InlineLoader.scss';

const InlineLoader = ({ className }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  const classes = classNames('InlineLoader', className);

  return (
    <div className={classes}>
      <Loader className="InlineLoader__loader" />
      <span className="InlineLoader__text">{T.translate('LOADING')}</span>
    </div>
  );
};

InlineLoader.propTypes = {
  className: PropTypes.string
};

export default InlineLoader;
